"use client";

import { useTranslations } from "next-intl";

import { Button } from "@/shared/components/button";
import { tp } from "@/shared/utils/typograf";

export type CookieBannerProps = {
  onAcceptAll: () => void;
  onRejectOptional: () => void;
  onCustomize: () => void;
};

const secondaryButton =
  "h-11 grow rounded-2xl border-transparent bg-[#2A2A2A] px-3.5 text-sm hover:bg-[#343434]";

export const CookieBanner = (props: CookieBannerProps) => {
  const t = useTranslations("cookieConsent.banner");

  return (
    <section
      aria-label={tp.execute(t("label"))}
      className="fixed right-4 bottom-4 lg:right-6 lg:bottom-6 z-40 w-[420px] max-w-[calc(100vw-2rem)] space-y-4 rounded-2xl bg-[#141414] p-4 shadow-[0px_0px_24px_0px_#00000066]"
    >
      <div className="space-y-2">
        <h2 className="text-base leading-6 font-medium text-white">
          {tp.execute(t("title"))}
        </h2>
        <p className="text-sm leading-5 text-[#7B7B87]">
          {tp.execute(t("description"))}
        </p>
      </div>
      <div className="space-y-2">
        <Button
          className="h-11 w-full rounded-2xl text-sm"
          onClick={props.onAcceptAll}
        >
          {tp.execute(t("acceptAll"))}
        </Button>
        <div className="flex flex-wrap gap-2">
          <Button
            variant="secondary"
            className={`${secondaryButton} basis-[57.9897%]`}
            onClick={props.onRejectOptional}
          >
            {tp.execute(t("rejectOptional"))}
          </Button>
          <Button
            variant="secondary"
            className={`${secondaryButton} basis-[39.9485%]`}
            onClick={props.onCustomize}
          >
            {tp.execute(t("customize"))}
          </Button>
        </div>
      </div>
    </section>
  );
};
